module.exports = __webpack_public_path__ + "static/media/img1.2e5df76a.png";